"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CascaderLoading = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var tips_1 = require("../tips");
function CascaderLoading(_a) {
    var onLoad = _a.onLoad;
    var _b = tslib_1.__read(react_1.useState(false), 2), error = _b[0], setError = _b[1];
    react_1.useEffect(function () {
        handleLoad();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    function handleLoad() {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setError(false);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, onLoad()];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        _1 = _a.sent();
                        setError(true);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    }
    if (error) {
        return react_1.default.createElement(tips_1.ErrorTip, { onRetry: handleLoad });
    }
    return react_1.default.createElement(tips_1.LoadingTip, null);
}
exports.CascaderLoading = CascaderLoading;
CascaderLoading.displayName = "CascaderLoading";
//# sourceMappingURL=CascaderLoading.js.map